import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ScreenFrame, ListCard, EmptyState, ViewToggle } from '../PrototypeShared';
import { Assignment } from '@mui/icons-material';

const MOCK_ORDERS = [
  { id: 'PO-001', product: 'Demo Product A', status: 'Confirmed', date: '2024-03-10' },
  { id: 'PO-002', product: 'Demo Product B', status: 'Tentative', date: '2024-03-11' },
];

export default function ProductionOrdersScreen() {
  const [view, setView] = useState('list');
  const [planningView, setPlanningView] = useState('confirmed'); // confirmed | tentative

  const items = view === 'empty' ? [] : planningView === 'all' ? MOCK_ORDERS : MOCK_ORDERS.filter((o) => o.status.toLowerCase() === planningView);

  return (
    <ScreenFrame
      title="Production orders"
      actions={
        <>
          <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }]} />
          <Button component={Link} to="/prototype/production-planning" variant="outlined" size="small">Planning</Button>
          <Button component={Link} to="/prototype/production-orders/new" startIcon={<Add />} variant="contained" size="small">New order</Button>
        </>
      }
    >
      <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
        <Button size="small" variant={planningView === 'confirmed' ? 'contained' : 'outlined'} onClick={() => setPlanningView('confirmed')}>Confirmed</Button>
        <Button size="small" variant={planningView === 'tentative' ? 'contained' : 'outlined'} onClick={() => setPlanningView('tentative')}>Tentative</Button>
        <Button size="small" variant={planningView === 'all' ? 'contained' : 'outlined'} onClick={() => setPlanningView('all')}>All</Button>
      </Box>
      {view === 'empty' && (
        <EmptyState icon={Assignment} title="No production orders" description="Create an order or switch to Planning view." actionLabel="New order" onAction={() => window.location.assign('/prototype/production-orders/new')} />
      )}
      {view === 'list' && items.length > 0 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {items.map((o) => (
            <ListCard key={o.id} title={o.id} subtitle={`${o.product} · ${o.date}`} status={o.status} to={`/prototype/production-orders/${o.id}/edit`} />
          ))}
        </Box>
      )}
    </ScreenFrame>
  );
}
